import { FC } from 'react';
import ProTable, { TableProps } from './table';
import ProTableColumn, { ColumnProps } from './column';
import ProTableColumnGroup, { ColumnGroupProps } from './columnGroup';
import TableSummary, { ITableSummaryComponent } from './summary';

export type ITableComponent = FC<TableProps<any>> & {
  Column: FC<ColumnProps<any>>;
  ColumnGroup: FC<ColumnGroupProps<any>>;
  Summary: ITableSummaryComponent;
};

const TransTable = ProTable as ITableComponent;
TransTable.Column = ProTableColumn;
TransTable.ColumnGroup = ProTableColumnGroup;
TransTable.Summary = TableSummary;

export default TransTable;
